module.exports = __webpack_public_path__ + "img/18_68.c198bc3b.png";